module.exports = __webpack_public_path__ + "img/pantalla-7-8.9efe1920.png";